import React from 'react';
import ReactDOM from 'react-dom/client';

async function RecentlyViewed(el, cookies) {
  let data = [];
  let api = el.dataset.api;

  const fetchData = async () => {
    for (const [key, cookie] of cookies.slice(0, cookies.length).entries()) {
      let cookieParts = cookie.split(':');
      let url = api.replace('{entity_type}', cookieParts[0]).replace('{entity_id}', cookieParts[1]);

      await fetch(url).then((response) => {
        if (response.ok) {
          return response;
        }
      })
      .then(async (body) => {
        const json = await body.json();
        data.push(
          <div className={'card'} key={key} dangerouslySetInnerHTML={{__html: json.card}}/>
        );
      })
      .catch(() => {});

    }

    let root = ReactDOM.createRoot(el.querySelector('.card-slider__slides'));
    await root.render(data)
  }

  await fetchData().catch(fault => {
    console.log(fault);
  });

  return el;
}

export default RecentlyViewed;
